// extracted by mini-css-extract-plugin
export default {"card-header":"Collection_card-header__o2dWG","cardHeader":"Collection_card-header__o2dWG"};